module.exports = __webpack_public_path__ + "static/media/3DPPA17.bade70a1.jpg";